import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Use cookies as primary, fall back to localStorage tokens
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  // Admin token via Authorization header for admin endpoints
  const adminToken = localStorage.getItem("admin_token");
  const userToken = localStorage.getItem("session_token");
  const url = config.url || "";
  if (url.startsWith("/admin")) {
    if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  } else {
    if (userToken && !config.headers.Authorization) config.headers.Authorization = `Bearer ${userToken}`;
  }
  return config;
});

export const initials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return parts[0].slice(0, 2).toUpperCase();
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const sec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (sec < 60) return "just now";
  if (sec < 3600) return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  if (sec < 86400 * 7) return `${Math.floor(sec / 86400)}d ago`;
  return d.toLocaleDateString();
};

export const showToast = (msg) => {
  const t = document.createElement("div");
  t.className = "toast";
  t.innerText = msg;
  document.body.appendChild(t);
  setTimeout(() => t.remove(), 2400);
};

export const showWelcomeToast = (username) => {
  // Strip any leading @ so the template handles both "user" and "@user"
  const u = (username || "").replace(/^@/, "");
  // De-dupe: if the welcome toast is already on screen, do nothing.
  if (document.querySelector(".toast.welcome-toast")) return;
  const t = document.createElement("div");
  t.className = "toast welcome-toast";
  // Build DOM manually to safely embed the username and the survey link
  const msg = document.createElement("span");
  msg.className = "wt-msg";
  msg.append(
    "Welcome to LANTEN, ",
  );
  const userEl = document.createElement("strong");
  userEl.className = "wt-user";
  userEl.innerText = `@${u}`;
  msg.appendChild(userEl);
  msg.append(" 👋 — ");
  const link = document.createElement("a");
  link.className = "wt-cta";
  link.href = "https://forms.gle/BnngD4XPsApUfvak8";
  link.target = "_blank";
  link.rel = "noreferrer";
  link.innerText = "Fill in the LANTEN Survey";
  msg.appendChild(link);
  msg.append(" to help us build something meaningful.");
  t.appendChild(msg);
  const closeBtn = document.createElement("button");
  closeBtn.className = "wt-close";
  closeBtn.setAttribute("aria-label", "Dismiss");
  closeBtn.innerText = "✕";
  closeBtn.onclick = () => t.remove();
  t.appendChild(closeBtn);
  document.body.appendChild(t);
  // Auto-dismiss after 8s so users have time to click
  setTimeout(() => { if (t.parentNode) t.remove(); }, 8000);
};
